module.exports = __webpack_public_path__ + "static/media/UKD SIGNET_2zeilig_weiss.d821210e.png";